// Email: regex razonablemente estricto sin pretender RFC perfecto.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isValidEmail(value) {
  return EMAIL_RE.test(String(value || "").trim());
}

// ─── RUT chileno con módulo 11 ────────────────────────────────────
// Acepta entradas como "12.345.678-K", "12345678K", "12345678-9".
function cleanRut(rut) {
  return String(rut || "").replace(/[.\s]/g, "").trim().toUpperCase();
}

function computeDv(numericRut) {
  let sum = 0;
  let multiplier = 2;
  for (let i = numericRut.length - 1; i >= 0; i--) {
    sum += Number(numericRut[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }
  const remainder = 11 - (sum % 11);
  if (remainder === 11) return "0";
  if (remainder === 10) return "K";
  return String(remainder);
}

export function isValidRut(rut) {
  const cleaned = cleanRut(rut);
  const match = cleaned.match(/^(\d{1,8})-?([0-9K])$/);
  if (!match) return false;
  const [, body, dv] = match;
  return computeDv(body) === dv;
}

export function formatRut(rut) {
  const cleaned = cleanRut(rut).replace(/-/g, "");
  if (cleaned.length < 2) return cleaned;
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);
  // Insertar puntos cada 3 dígitos desde la derecha del body.
  const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${withDots}-${dv}`;
}

// ─── Password strength ────────────────────────────────────────────
// Devuelve { score: 0..4, label, color, suggestions: [] }.
export function passwordStrength(password) {
  const value = String(password || "");
  const checks = {
    length: value.length >= 10,
    lower: /[a-z]/.test(value),
    upper: /[A-Z]/.test(value),
    digit: /\d/.test(value),
    symbol: /[^A-Za-z0-9]/.test(value),
  };
  const passed = Object.values(checks).filter(Boolean).length;

  let score = 0;
  if (value.length === 0) score = 0;
  else if (value.length < 6) score = 1;
  else if (passed <= 2) score = 1;
  else if (passed === 3) score = 2;
  else if (passed === 4) score = 3;
  else score = 4;

  const labels = ["", "Débil", "Aceptable", "Fuerte", "Excelente"];
  const colors = ["#e2e8f0", "#dc2626", "#d97706", "#0353a4", "#059669"];

  const suggestions = [];
  if (!checks.length) suggestions.push("Mínimo 10 caracteres");
  if (!checks.lower || !checks.upper) suggestions.push("Mezcla mayúsculas y minúsculas");
  if (!checks.digit) suggestions.push("Incluye al menos un número");
  if (!checks.symbol && score < 4) suggestions.push("Agregar un símbolo aumenta la fortaleza");

  return { score, label: labels[score], color: colors[score], suggestions };
}
